import { render, staticRenderFns } from "./4-3.RecommendedProduct.vue?vue&type=template&id=d34b0502"
import script from "./4-3.RecommendedProduct.vue?vue&type=script&lang=js"
export * from "./4-3.RecommendedProduct.vue?vue&type=script&lang=js"
import style0 from "./4-3.RecommendedProduct.vue?vue&type=style&index=0&id=d34b0502&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports